import { createSelector } from '@reduxjs/toolkit';
import { getSelectedFlightData } from './order';
import { businessFlightsSelector } from '../../CheckoutRoutes/PackageCheckout/store/flights/selectors';
import { EXTRAS } from '../constants/extras';

import { extrasByTourIdSelector } from './services';
import type { FlightsData } from '../../CheckoutRoutes/PackageCheckout/types/flights';

const extraSelector = createSelector(
  [
    (state, tourId) => extrasByTourIdSelector(state, tourId),
    (_state, _tourId, name) => name,
  ],
  (extras, name) => extras.find((extra) => extra.code_name === name),
);

export const visaRiskSelector = (state, tourId) =>
  extraSelector(state, tourId, EXTRAS.VISA_RISK);

export const getUpgradedFlight = createSelector(
  [getSelectedFlightData, businessFlightsSelector],
  (selectedFlight, businessFlights): FlightsData | false | object => {
    if (
      !selectedFlight ||
      selectedFlight.to.business ||
      !businessFlights.length
    ) {
      return false;
    }

    return businessFlights.reduce((result, flight) => {
      if (!result && flight.to.flight_id === selectedFlight.to.flight_id) {
        const back = flight.back.find(
          (backFlight) =>
            backFlight.flight_id === selectedFlight.back[0].flight_id,
        );
        if (back) {
          return { to: flight.to, back: [back] };
        }
      }
      return result;
    }, {});
  },
);

export const isChangableFlight = (flight: FlightsData) =>
  flight?.back[0].operator_id === 7 &&
  !flight.extras.find((extra) => extra.code_name === EXTRAS.FLIGHT_LOCK);
